import SecondaryNavbar from "./SecondaryNavbar";

export default SecondaryNavbar;